export const BlockTypes = {
    DATE: Symbol('DATE'),
    KEYWORD: Symbol('KEYWORD'),
    LEVEL: Symbol('LEVEL'),
    MONTH: Symbol('MONTH'),
    NULL: Symbol('NULL'),
    NUMBER: Symbol('NUMBER'),
    PERCENT: Symbol('PERCENT'),
    PRICE: Symbol('PRICE'),
    RANK: Symbol('RANK'),
    RATING: Symbol('RATING'),
    STRING: Symbol('STRING'),
    TREND: Symbol('TREND'),
};

export const SourceTypes = {
    Amazon: Symbol('Amazon'),
    Any: Symbol('Any'),
    Google: Symbol('Google'),
};

export const AllColumns = [
    'keyword',
    'searchVolumeTrend',
    'searchVolume',
    'numberOfResults',
    'resultsPerPage',
    'peekVolume',
    'peekMonth',
    'monthlySalesEstimate',
    'monthlyRevenueEstimate',
    'averageTopThreePrice',
    'averageTopThreeReviews',
    'averageTopThreeRatings',
    'averagePageOneReviews',
    'averagePageOneRatings',
    'averagePageOnePrice',
    'searchVolumeGoogle',
    'searchVolumeTrendGoogle',
];

export const ColumnsInfo = [
    {
        blockType: BlockTypes.KEYWORD,
        id: 'keyword',
        source: SourceTypes.Any,
        title: 'Keyword',
    },
    {
        altTitle: 'Search Volume',
        blockType: BlockTypes.NUMBER,
        id: 'searchVolume',
        info: 'The estimate number of searches the keyword/phrase gets per month on Amazon',
        source: SourceTypes.Amazon,
        title: 'Search Volume',
    },
    {
        blockType: BlockTypes.PRICE,
        id: 'averagePageOnePrice',
        info: 'The average price for the first page of results for the keyword/phrase',
        source: SourceTypes.Amazon,
        title: 'Amazon P1 Avg Product Price',
    },
    {
        blockType: BlockTypes.NUMBER,
        id: 'averagePageOneReviews',
        info: 'The average review count for the first page of results for the keyword/phrase',
        source: SourceTypes.Amazon,
        title: 'Amazon P1 Avg Review Count',
    },
    {
        blockType: BlockTypes.RATING,
        id: 'averagePageOneRatings',
        info: 'The average review star rating of the first page of results for the keyword/phrase',
        source: SourceTypes.Amazon,
        title: 'Amazon P1 Avg Review Rating',
    },
    {
        blockType: BlockTypes.TREND,
        id: 'searchVolumeTrend',
        info: 'How much the keyword/phrase is trending up or down compared to last month',
        source: SourceTypes.Amazon,
        title: 'Amazon Search Trend',
    },
    {
        blockType: BlockTypes.PRICE,
        id: 'averageTopThreePrice',
        info: 'The average price of the top 3 products for the keyword/phrase',
        source: SourceTypes.Amazon,
        title: 'Amazon T3 Avg Product Price',
    },
    {
        blockType: BlockTypes.NUMBER,
        id: 'averageTopThreeReviews',
        info: 'The average review count of the top 3 products for the keyword/phrase',
        source: SourceTypes.Amazon,
        title: 'Amazon T3 Avg Review Count',
    },
    {
        blockType: BlockTypes.RATING,
        id: 'averageTopThreeRatings',
        info: 'The average review star rating of the top 3 products for the keyword/phrase',
        source: SourceTypes.Amazon,
        title: 'Amazon T3 Avg Review Rating',
    },
    {
        blockType: BlockTypes.NUMBER,
        id: 'searchVolumeGoogle',
        info: 'The estimated number of searches per month the keyword/phrase gets on Google',
        source: SourceTypes.Google,
        title: 'Google Monthly Search Volume',
    },
    {
        blockType: BlockTypes.TREND,
        id: 'searchVolumeTrendGoogle',
        info: 'How much the keyword/phrase is trending up or down in Google compared to last month',
        source: SourceTypes.Google,
        title: 'Google Search Trend (vs Last Month)',
    },
    {
        blockType: BlockTypes.NUMBER,
        id: 'resultsPerPage',
        info: 'How many listings there are on each page of results',
        source: SourceTypes.Amazon,
        title: 'Listings Per Page',
    },
    {
        blockType: BlockTypes.NUMBER,
        id: 'numberOfResults',
        info: 'How many product listings currently exist for the keyword/phrase',
        source: SourceTypes.Amazon,
        title: 'Product Listings',
    },
    {
        blockType: BlockTypes.NUMBER,
        id: 'peekVolume',
        info: 'The highest search volume we have recorded for the keyword/phrase',
        source: SourceTypes.Amazon,
        title: 'Peak Search Volume',
    },
    {
        blockType: BlockTypes.MONTH,
        id: 'peekMonth',
        info: 'The month that we have the highest number of searches recorded for the keyword/phrase',
        source: SourceTypes.Amazon,
        title: 'Peak Month',
    },
    {
        blockType: BlockTypes.NUMBER,
        id: 'monthlySalesEstimate',
        info: 'The estimated number of sales per month for that keyword/phrase',
        source: SourceTypes.Amazon,
        title: 'Sales Estimate',
    },
    {
        blockType: BlockTypes.NUMBER,
        id: 'estimatedSales',
        info: 'The estimated number of sales per month for that keyword/phrase',
        source: SourceTypes.Amazon,
        title: 'Sales Estimate',
    },
    {
        blockType: BlockTypes.PRICE,
        id: 'monthlyRevenueEstimate',
        info: 'The estimated monthly revenue for that keyword/phrase',
        source: SourceTypes.Amazon,
        title: 'Revenue Estimate',
    },
    {
        blockType: BlockTypes.NUMBER,
        id: 'salesVelocity',
        info: 'The estimated number of sales you need to make per day targeting this keyword/phrase to rank on page 1.',
        title: 'Daily Min.',
    },
    {
        blockType: BlockTypes.RANK,
        id: 'ranking',
        title: 'Rank',
    },
    {
        blockType: BlockTypes.RANK,
        id: 'previousRanking',
        title: 'Previous Rank',
    },
    {
        blockType: BlockTypes.NUMBER,
        id: 'wordCount',
        title: 'Word Count',
    },
    {
        blockType: BlockTypes.PERCENT,
        id: 'relevance',
        info: 'How related the phrase is to the search term',
        title: 'Relevance',
    },
    {
        blockType: BlockTypes.NUMBER,
        id: 'sessions',
        info: 'How many views of the product page',
        title: 'Sessions',
    },
    {
        blockType: BlockTypes.NUMBER,
        id: 'unitsOrdered',
        title: 'Units order',
    },
    {
        blockType: BlockTypes.PERCENT,
        id: 'unitSessionPercentage',
        title: 'Conversion Rate',
    },
    {
        blockType: BlockTypes.PRICE,
        id: 'orderedProductSales',
        title: 'Sales',
    },
    {
        blockType: BlockTypes.DATE,
        id: 'fromDate',
        title: 'Date',
    },
    {
        blockType: BlockTypes.STRING,
        id: 'asin',
        title: 'ASIN',
    },
    {
        blockType: BlockTypes.NUMBER,
        id: 'reviewsCount',
        title: '# Reviews',
    },
    {
        blockType: BlockTypes.NUMBER,
        id: 'reviews',
        title: '# Reviews',
    },
    {
        blockType: BlockTypes.RATING,
        id: 'rating',
        title: 'Rating',
    },
    {
        blockType: BlockTypes.RANK,
        id: 'salesRank',
        title: 'Sales Rank',
    },
    {
        blockType: BlockTypes.NUMBER,
        id: 'salesVolume',
        title: 'Sales Volume',
    },
    {
        blockType: BlockTypes.PERCENT,
        id: 'salesVolumePercent',
        title: '% Sales Volume',
    },
    {
        blockType: BlockTypes.NUMBER,
        id: 'unitVolume',
        title: 'Unit Volume',
    },
    {
        blockType: BlockTypes.PERCENT,
        id: 'unitVolumePercent',
        title: '% Unit Volume',
    },
    {
        blockType: BlockTypes.PERCENT,
        id: 'marketSharePercent',
        title: '% Market Share',
    },
];
